export default __webpack_public_path__ + "static/media/brand_01.064eb934.png";